import React from 'react';
import './App.css';
import './css/navbar.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; 

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Vivek from './pages/Vivek';
import Priyanka from './pages/Priyanka';
import Contact from './components/Contact';
import Gallery from './components/Gallery';


function App() {
  return (
    <Router>
      <div className="Apps">
        <Navbar />
        <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/Vivek" element={<Vivek />} />
        <Route path="/Priyanka" element={<Priyanka />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Gallery" element={<Gallery />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
